import { pgTable, timestamp, uniqueIndex, uuid } from 'drizzle-orm/pg-core';

import { departments } from './departments';
import { organizations } from './organizations';
import { tenantOrgIsolationPolicy } from './rls';
import { tenants } from './tenants';
import { users } from './users';

export const userDepartments = pgTable(
  'user_departments',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    tenantId: uuid('tenant_id')
      .notNull()
      .references(() => tenants.id),
    orgId: uuid('org_id')
      .notNull()
      .references(() => organizations.id),
    userId: uuid('user_id')
      .notNull()
      .references(() => users.id),
    departmentId: uuid('department_id')
      .notNull()
      .references(() => departments.id),
    createdAt: timestamp('created_at').notNull().defaultNow()
  },
  (t) => [
    uniqueIndex('user_departments_user_dept_unique').on(t.userId, t.departmentId),
    tenantOrgIsolationPolicy()
  ]
).enableRLS();
